import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';

const candidates = [
  { name: 'Arjun Sharma',    role: 'Senior React Developer',    location: 'Mumbai, India',     experience: '5 years',  skills: ['React', 'Node.js', 'MongoDB'],        available: true,  avatar: 'AS', color: '#0066FF', bg: '#e8f0ff' },
  { name: 'Priya Mehta',     role: 'UI/UX Designer',            location: 'Bangalore, India',  experience: '3 years',  skills: ['Figma', 'Adobe XD', 'CSS'],           available: true,  avatar: 'PM', color: '#ec4899', bg: '#fdf0f7' },
  { name: 'Rahul Verma',     role: 'Data Analyst',              location: 'Delhi, India',      experience: '4 years',  skills: ['Python', 'SQL', 'Power BI'],          available: false, avatar: 'RV', color: '#f59e0b', bg: '#fff8e6' },
  { name: 'Sneha Patel',     role: 'Digital Marketing Manager', location: 'Pune, India',       experience: '6 years',  skills: ['SEO', 'Google Ads', 'Analytics'],     available: true,  avatar: 'SP', color: '#00C896', bg: '#e6fff6' },
  { name: 'Vikram Singh',    role: 'DevOps Engineer',           location: 'Hyderabad, India',  experience: '7 years',  skills: ['AWS', 'Docker', 'Kubernetes'],        available: true,  avatar: 'VS', color: '#8b5cf6', bg: '#f3eeff' },
  { name: 'Ananya Gupta',    role: 'HR Manager',                location: 'Chennai, India',    experience: '5 years',  skills: ['Recruitment', 'HRIS', 'Compliance'],  available: false, avatar: 'AG', color: '#06b6d4', bg: '#e0f9ff' },
  { name: 'Karan Malhotra',  role: 'Product Manager',           location: 'Noida, India',      experience: '8 years',  skills: ['Agile', 'Jira', 'Roadmapping'],       available: true,  avatar: 'KM', color: '#f97316', bg: '#fff4ed' },
  { name: 'Divya Nair',      role: 'Content Writer',            location: 'Remote',            experience: '2 years',  skills: ['Copywriting', 'SEO', 'WordPress'],    available: true,  avatar: 'DN', color: '#10b981', bg: '#ecfdf5' },
  { name: 'Rohit Joshi',     role: 'Full Stack Developer',      location: 'Ahmedabad, India',  experience: '4 years',  skills: ['Vue.js', 'Laravel', 'MySQL'],         available: true,  avatar: 'RJ', color: '#6366f1', bg: '#eef2ff' },
];

const categories = ['All', 'Technology', 'Design', 'Marketing', 'HR', 'Finance', 'Sales'];
const experiences = ['All', 'Fresher', '1-3 years', '3-5 years', '5+ years'];

const stats = [
  { num: '120K+', label: 'Registered Candidates', icon: 'fa-users',      color: '#0066FF', bg: '#e8f0ff' },
  { num: '85%',   label: 'Placement Rate',         icon: 'fa-chart-line', color: '#00C896', bg: '#e6fff6' },
  { num: '48hrs', label: 'Avg. Hire Time',          icon: 'fa-clock',      color: '#f59e0b', bg: '#fff8e6' },
  { num: '8K+',   label: 'Companies Hiring',        icon: 'fa-building',   color: '#8b5cf6', bg: '#f3eeff' },
];

export default function BrowseCandidates() {
  const [search, setSearch]     = useState('');
  const [category, setCategory] = useState('All');
  const [exp, setExp]           = useState('All');
  const [onlyAvailable, setOnlyAvailable] = useState(false);

  const filtered = candidates.filter(c => {
    const matchSearch = c.name.toLowerCase().includes(search.toLowerCase()) ||
                        c.role.toLowerCase().includes(search.toLowerCase()) ||
                        c.skills.some(s => s.toLowerCase().includes(search.toLowerCase()));
    const matchAvail  = !onlyAvailable || c.available;
    return matchSearch && matchAvail;
  });

  return (
    <>
      <PageHeader title="Browse Candidates" breadcrumb="Browse Candidates" />

      {/* Hero */}
      <section style={{ background: 'linear-gradient(135deg, #0A1628 0%, #1a2d4f 100%)', padding: '60px 0' }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <span style={{ background: 'rgba(0,102,255,0.25)', color: '#60a5fa', fontSize: 12, fontWeight: 700, padding: '6px 16px', borderRadius: 50, letterSpacing: 1 }}>FOR EMPLOYERS</span>
          <h2 style={{ color: '#fff', fontWeight: 800, fontSize: 34, margin: '16px 0 12px' }}>Find Your Next Star Employee</h2>
          <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: 15, maxWidth: 520, margin: '0 auto 32px' }}>
            Browse thousands of verified, skilled candidates ready to join your team today.
          </p>
          <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
            {stats.map((s, i) => (
              <div key={i} style={{ background: 'rgba(255,255,255,0.08)', borderRadius: 14, padding: '16px 28px', textAlign: 'center', backdropFilter: 'blur(10px)' }}>
                <div style={{ fontSize: 24, fontWeight: 800, color: '#fff' }}>{s.num}</div>
                <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.6)', marginTop: 3 }}>{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Search & Filters */}
      <section style={{ background: '#fff', borderBottom: '1px solid #f0f0f0', padding: '24px 0', position: 'sticky', top: 0, zIndex: 100, boxShadow: '0 2px 12px rgba(0,0,0,0.04)' }}>
        <div className="container">
          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center' }}>
            <div style={{ flex: 1, minWidth: 240, display: 'flex', alignItems: 'center', gap: 10, background: '#fafbff', border: '1.5px solid #eef0f8', borderRadius: 12, padding: '11px 16px' }}>
              <i className="fa fa-search" style={{ color: '#aaa' }}></i>
              <input type="text" placeholder="Search by name, role or skill..." value={search} onChange={e => setSearch(e.target.value)}
                style={{ border: 'none', outline: 'none', fontSize: 14, background: 'transparent', width: '100%' }} />
            </div>
            <select value={category} onChange={e => setCategory(e.target.value)}
              style={{ padding: '11px 16px', borderRadius: 12, border: '1.5px solid #eef0f8', fontSize: 13, fontWeight: 600, color: '#444', background: '#fafbff', cursor: 'pointer', outline: 'none' }}>
              {categories.map(c => <option key={c}>{c}</option>)}
            </select>
            <select value={exp} onChange={e => setExp(e.target.value)}
              style={{ padding: '11px 16px', borderRadius: 12, border: '1.5px solid #eef0f8', fontSize: 13, fontWeight: 600, color: '#444', background: '#fafbff', cursor: 'pointer', outline: 'none' }}>
              {experiences.map(e => <option key={e}>{e}</option>)}
            </select>
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, fontWeight: 600, color: '#444', cursor: 'pointer', padding: '11px 16px', borderRadius: 12, border: '1.5px solid #eef0f8', background: onlyAvailable ? '#e6fff6' : '#fafbff', transition: 'all .2s' }}>
              <input type="checkbox" checked={onlyAvailable} onChange={e => setOnlyAvailable(e.target.checked)} style={{ accentColor: '#00C896' }} />
              Available Now
            </label>
          </div>
        </div>
      </section>

      {/* Candidates Grid */}
      <section className="section-pad">
        <div className="container">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 28 }}>
            <p style={{ color: '#888', fontSize: 14, margin: 0 }}>Showing <strong style={{ color: '#0A1628' }}>{filtered.length}</strong> candidates</p>
            <Link to="/post-job" className="jd-apply-btn" style={{ textDecoration: 'none' }}>
              <i className="fa fa-plus me-2"></i> Post a Job
            </Link>
          </div>

          {filtered.length === 0 ? (
            <div className="jl-empty">
              <i className="fa fa-users"></i>
              <h5>No candidates found</h5>
              <p>Try adjusting your search or filters</p>
            </div>
          ) : (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 24 }} className="cat-why-grid">
              {filtered.map((c, i) => (
                <div key={i} className="cat-why-card" style={{ background: '#fff', borderRadius: 20, border: '1.5px solid #eef0f8', padding: '28px 24px', boxShadow: '0 4px 20px rgba(0,0,0,0.04)', transition: 'all .25s', position: 'relative' }}>
                  {/* Available Badge */}
                  <span style={{ position: 'absolute', top: 16, right: 16, fontSize: 11, fontWeight: 700, padding: '3px 10px', borderRadius: 50, background: c.available ? '#e6fff6' : '#f5f5f5', color: c.available ? '#00C896' : '#aaa' }}>
                    {c.available ? '● Available' : '○ Not Available'}
                  </span>

                  {/* Avatar + Info */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 16 }}>
                    <div style={{ width: 56, height: 56, borderRadius: '50%', background: c.bg, color: c.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, fontWeight: 800, flexShrink: 0 }}>
                      {c.avatar}
                    </div>
                    <div>
                      <h5 style={{ fontSize: 15, fontWeight: 700, color: '#0A1628', margin: '0 0 3px' }}>{c.name}</h5>
                      <p style={{ fontSize: 13, color: '#0066FF', fontWeight: 600, margin: 0 }}>{c.role}</p>
                    </div>
                  </div>

                  {/* Meta */}
                  <div style={{ display: 'flex', gap: 16, marginBottom: 14 }}>
                    <span style={{ fontSize: 12, color: '#888' }}><i className="fa fa-map-marker-alt me-1" style={{ color: c.color }}></i>{c.location}</span>
                    <span style={{ fontSize: 12, color: '#888' }}><i className="fa fa-briefcase me-1" style={{ color: c.color }}></i>{c.experience}</span>
                  </div>

                  {/* Skills */}
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 20 }}>
                    {c.skills.map((s, j) => (
                      <span key={j} style={{ fontSize: 11, fontWeight: 600, padding: '4px 10px', borderRadius: 50, background: c.bg, color: c.color }}>{s}</span>
                    ))}
                  </div>

                  {/* Actions */}
                  <div style={{ display: 'flex', gap: 10, paddingTop: 14, borderTop: '1px solid #f5f5f5' }}>
                    <button style={{ flex: 1, padding: '9px', borderRadius: 10, border: '1.5px solid #eef0f8', background: '#fafbff', fontSize: 13, fontWeight: 600, cursor: 'pointer', color: '#555', transition: 'all .2s' }}>
                      <i className="fa fa-eye me-1"></i> View Profile
                    </button>
                    <button style={{ flex: 1, padding: '9px', borderRadius: 10, border: 'none', background: c.available ? '#0066FF' : '#e0e0e0', fontSize: 13, fontWeight: 600, cursor: c.available ? 'pointer' : 'not-allowed', color: c.available ? '#fff' : '#aaa', transition: 'all .2s' }}
                      disabled={!c.available}>
                      <i className="fa fa-paper-plane me-1"></i> Contact
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-card">
            <div className="cta-left">
              <h2>Ready to Hire Top Talent?</h2>
              <p>Post a job and reach 120,000+ qualified candidates today.</p>
            </div>
            <div className="cta-right">
              <Link to="/post-job" className="cta-btn-white">Post a Job</Link>
              <Link to="/pricing" className="cta-btn-outline">View Pricing</Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
